import { MerchantService } from './../../_services/merchant.service';
import { CmsService } from './../../_services/strapi.service';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Component, inject, OnInit } from '@angular/core';
import { ConfirmDialogComponent } from '../../_components/confirm-dialog/confirm-dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LoaderService } from '../../_services/loader.service';
import { saveAs } from 'file-saver';

@Component({
    selector: 'app-registration',
    templateUrl: './registration.component.html',
    styleUrls: ['./registration.component.scss'],
    standalone: false
})
export class RegistrationComponent implements OnInit {
  private readonly fb: UntypedFormBuilder = inject(UntypedFormBuilder);
  private readonly merchantService: MerchantService = inject(MerchantService);
  private readonly cmsService: CmsService = inject(CmsService);
  private readonly dialog: MatDialog = inject(MatDialog);
  private readonly router: Router = inject(Router);
  private readonly loaderService: LoaderService = inject(LoaderService);

  merchant: any;
  registrationForm = this.fb.group({
    name: ['', [Validators.required]],
    email: ['', [Validators.email, Validators.required]],
    phone: ['+39 ', [Validators.pattern('[+]\\d{1,3}\\s{1}(\\d{7,10}|\\s{0})'), Validators.required, Validators.minLength(8)]]
  });
  genericError = $localize `:@@interceptor-genericError: Errore Generico`;
  attention = $localize `:@@interceptor-attention: Attenzione`;
  successfullyRegistered = $localize `:@@successfully-registered: Registrazione avvenuta con successo, controlla la tua mail per accedere.`;
  title = $localize `:@@registration: Registrazione`;
  error = $localize `:@@error: Errore`;
  dialogRef: MatDialogRef<ConfirmDialogComponent>;

  ngOnInit(): void {
  }

  registration() {
    this.loaderService.startLoader();
    this.merchantService.register(this.registrationForm.value).subscribe((merchant) => {
      this.merchant = merchant;
      if (!this.dialogRef) {
        this.dialogRef = this.dialog.open(ConfirmDialogComponent, {
          width: '450px',
          data: { type: 'ALERT', title: this.title, message: this.successfullyRegistered }
        });
        this.dialogRef.afterClosed().subscribe(() => {
          this.dialogRef = null;
          this.merchantService.resetCurrentMerchant();

          this.router.navigate(['public/home'], {});
        });
        this.loaderService.stopLoader();
      }
      },
    (err) => {
      this.loaderService.stopLoader();
      this.errorDialog(this.errorHandler(err));
    });
  }

  errorDialog(message: string): void {
    if (!this.dialogRef) {
      this.dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: '450px',
        data: { type: 'ALERT', title: this.error, message }
      });
      this.dialogRef.afterClosed().subscribe(() => {
        this.dialogRef = null;
      });
    }
  }

  errorHandler(error) {
    if (error.error) {
      if (error.error.message) {
        if (typeof error.error.message === 'string') {
         return error.error.message;
        } else {
          return this.genericError;
        }
      } else {
        return this.genericError;
      }
    } else {
      return error.message;
    }
  }


  downloadPrivacyPolicy(): void {
    this.cmsService.getDocuments().subscribe(pdfs => {
      const privacyPdf = pdfs.find(pdf => pdf.visibility === 'privacy_policy');
      if (privacyPdf?.file?.url) {
        this.cmsService.downloadFile(privacyPdf.file.url).subscribe(blob => {
          saveAs(blob, privacyPdf.file.name);
        });
      }
    });
  }
}
